<template>
    <div>

    </div>
</template>

<script>
    import requestService from "../service/request";
    export default {
        name: "WxAuth",
        data(){
            return{
                appId: "wxae579da48853960c",
            }
        },
        created() {
          let userId = this.$route.query.state;
          if(userId){
               let data =new FormData();
               let code = this.$route.query.code;
               data.append("code",code);
               data.append("appId",this.appId);
               data.append("userId",userId);
               requestService.wechat.acceptInvite(data).then(res=>{
                   let data = res.data;
                   if(res.data.status === 200){
                       console.log(data);
                   }
               });
           }
          window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.biku.callshow";
        },
        mounted(){

        },
        methods:{

        }
    }
</script>

<style scoped>

</style>